export default __webpack_public_path__ + "navigation-overview-view-hierarchy-1200-c0477d4e8969612fd421013b18d96312.webp";